"use strict";
var IntervalObservable_1 = require('./IntervalObservable');
exports.interval = IntervalObservable_1.IntervalObservable.create;
//# sourceMappingURL=interval.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/re5pect/Desktop/siterepoProject/Admin panel/SiteRepoAdminPanel/~/rxjs/observable/interval.js
// module id = ../../../../rxjs/observable/interval.js
// module chunks = 3